/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Device_WebInputs */

const en_funnel_device_web = /** @type {(inputs: Funnel_Device_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web app`)
};

const es_funnel_device_web = /** @type {(inputs: Funnel_Device_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicación web`)
};

/**
* | output |
* | --- |
* | "Web app" |
*
* @param {Funnel_Device_WebInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_device_web = /** @type {((inputs?: Funnel_Device_WebInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Device_WebInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_device_web(inputs)
	return en_funnel_device_web(inputs)
});